// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__hv-eA","arrowLeft":"carousel_arrowLeft__tRknR","arrowRight":"carousel_arrowRight__wF7EM"};